var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.32 4.02941L9.12769 0.159201C8.93552 0.0547754 8.71955 0 8.5 0C8.28045 0 8.06448 0.0547754 7.87231 0.159201L0.68 4.03102C0.474601 4.14154 0.303142 4.30427 0.183528 4.50222C0.0639136 4.70016 0.000531461 4.92605 0 5.15631V12.8437C0.000531461 13.0739 0.0639136 13.2998 0.183528 13.4978C0.303142 13.6957 0.474601 13.8585 0.68 13.969L7.87231 17.8408C8.06448 17.9452 8.28045 18 8.5 18C8.71955 18 8.93552 17.9452 9.12769 17.8408L16.32 13.969C16.5254 13.8585 16.6969 13.6957 16.8165 13.4978C16.9361 13.2998 16.9995 13.0739 17 12.8437V5.15712C16.9999 4.92645 16.9367 4.70005 16.8171 4.50165C16.6975 4.30324 16.5258 4.14013 16.32 4.02941ZM8.5 1.2845L15.0662 4.82114L12.6331 6.1313L6.06606 2.59466L8.5 1.2845ZM8.5 8.35778L1.93375 4.82114L4.70442 3.32932L11.2707 6.86596L8.5 8.35778ZM1.30769 5.94643L7.84615 9.46539V16.361L1.30769 12.8445V5.94643ZM15.6923 12.8413L9.15385 16.361V9.46861L11.7692 8.06118V10.9299C11.7692 11.1004 11.8381 11.264 11.9607 11.3846C12.0834 11.5052 12.2497 11.5729 12.4231 11.5729C12.5965 11.5729 12.7628 11.5052 12.8854 11.3846C13.008 11.264 13.0769 11.1004 13.0769 10.9299V7.35707L15.6923 5.94643V12.8405V12.8413Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/boxIcon.50f193e87bee1393c187bce422a13128.svg";
export { ForwardRef as ReactComponent };